// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';
import AddressShow from './AddressShow';
import MethodPoint from './MethodPoint';
import { USE_POINT_CHILD_LEVEL, USE_POINT_PARENT_LEVEL } from '../../../constants';

function SettingAddress(props) {
  const { dataInfo, data, lotteryEvent, getPriceByPoint, getCheckPoint } = props;
  const usePointFlag = lotteryEvent?.use_point_flag;
  const hasUsePointFlag = lotteryEvent?.has_use_point_flag;

  const { t } = useTranslation();
  return (
    <>
      <div className="my-setting-address my-box-purchase NotoSansJP">
        <div className="title">
          <span className="title-quantity AOTFShinMaruGoPro">{t('titleAddressSetting')}</span>
        </div>
        <AddressShow dataInfo={dataInfo} data={data} />
      </div>
      {usePointFlag === USE_POINT_PARENT_LEVEL.canUsePoint &&
        hasUsePointFlag === USE_POINT_CHILD_LEVEL.canUsePoint && (
          <MethodPoint
            dataInfo={dataInfo}
            lotteryEvent={lotteryEvent}
            data={data}
            getPriceByPoint={getPriceByPoint}
            getCheckPoint={getCheckPoint}
          />
        )}
    </>
  );
}

export default SettingAddress;
